module.exports = __webpack_public_path__ + "static/venice20893-73a75d2afae2d2c3d791fa4026b404f3.webp";